// extracted by mini-css-extract-plugin
module.exports = {"slide":"Laj","title":"Lal","content":"Lan","text":"Lap","image":"Lar"};